export default {
    getDispatchConfiguration: (state) => {
        return state.dispatchConfiguration
    },
}
